import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationComponent } from './notification.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [NotificationComponent],
    imports: [CommonModule, TranslateModule],
    exports: [NotificationComponent]
})
export class NotificationModule {
}
